import http from '@/http/http.js'
const api = {
  item: {
    getItem: async function (id) {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/item/get/' + id).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    insertItem: async function (item) {
      return new Promise((resolve, reject) => {
        http.post(process.env.VUE_APP_API_ORIGIN + '/api/item/insert', item).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    updateItem: async function (item) {
      return new Promise((resolve, reject) => {
        http.put(process.env.VUE_APP_API_ORIGIN + '/api/item/update', item).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    getItemsCount: async function (params) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ORIGIN + '/api/items/count'
        if (params != null) {
          let urlParam = ''
          for (const key in params) {
            if (urlParam.length > 0) {
              urlParam = urlParam + '&'
            }
            urlParam = urlParam + key + '=' + encodeURIComponent(params[key])
          }
          if (urlParam.length > 0) {
            url = url + '?' + urlParam
          }
        }
        http.get(url).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    getItemList: async function (page, count, params) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ORIGIN + '/api/items/list/' + page + '/' + count
        if (params != null) {
          let urlParam = ''
          for (const key in params) {
            if (urlParam.length > 0) {
              urlParam = urlParam + '&'
            }
            urlParam = urlParam + key + '=' + encodeURIComponent(params[key])
          }
          if (urlParam.length > 0) {
            url = url + '?' + urlParam
          }
        }
        http.get(url).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    deleteItems: async function (ids) {
      return new Promise((resolve, reject) => {
        http.post(process.env.VUE_APP_API_ORIGIN + '/api/items/delete', ids).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    copyItem: async function (id) {
      return new Promise((resolve, reject) => {
        http.post(process.env.VUE_APP_API_ORIGIN + '/api/item/copy/' + id).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  area: {
    getPrefectures: async function () {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/area/prefectures/get').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    getDistricts: async function () {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/area/foreigns/get').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  brand: {
    getBrands: async function (name) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ORIGIN + '/api/brands/list'
        if (name != null) {
          url = url + '?name=' + name
        }
        http.get(url).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    getBrand: async function (id) {
      return new Promise((resolve, reject) => {
        const url = process.env.VUE_APP_API_ORIGIN + '/api/brands/id/' + id
        http.get(url).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    queryBrands: async function (name) {
      return new Promise((resolve, reject) => {
        const url = process.env.VUE_APP_API_ORIGIN + '/api/brands/query?name=' + encodeURIComponent(name)
        http.get(url).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  category: {
    getTopCategories: async function () {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/category/top/get').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    getSecondCategories: async function (id1st) {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/category/second/' + id1st + '/get').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    getThirdCategories: async function (id1st, id2nd) {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/category/third/' + id1st + '/' + id2nd + '/get').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  color: {
    getColorPatterns: async function () {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/color/pattern/list').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  delivery: {
    getDeliveryMethods: async function () {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/delivery/list').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    insertDeliveryMethods: async function (delivery) {
      return new Promise((resolve, reject) => {
        http.post(process.env.VUE_APP_API_ORIGIN + '/api/delivery/insert', delivery).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    updateDeliveryMethods: async function (delivery) {
      return new Promise((resolve, reject) => {
        http.put(process.env.VUE_APP_API_ORIGIN + '/api/delivery/update', delivery).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    deleteDeliveryMethods: async function (id) {
      return new Promise((resolve, reject) => {
        http.delete(process.env.VUE_APP_API_ORIGIN + '/api/delivery/delete/' + id).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  season: {
    getSeasons: async function () {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/seasons/get').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  size: {
    getSizeReferences: async function (id1st, id2nd, id3rd) {
      return new Promise((resolve, reject) => {
        const url = process.env.VUE_APP_API_ORIGIN + '/api/size/sizeref/get/' + id1st + '/' + id2nd + '/' + id3rd
        http.get(url).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    getSizeDetails: async function (id1st, id2nd, id3rd) {
      return new Promise((resolve, reject) => {
        const url = process.env.VUE_APP_API_ORIGIN + '/api/size/sizedetail/get/' + id1st + '/' + id2nd + '/' + id3rd
        http.get(url).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  theme: {
    getThemes: async function () {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/themes/get').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  image: {
    uploadImageFile: async function (params) {
      return new Promise((resolve, reject) => {
        http.post(process.env.VUE_APP_API_ORIGIN + '/api/upload', params).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  userconfig: {
    getConfiguration: async function (key) {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/userconfig/' + key).then(response => {
          resolve(response.data.value)
        }).catch(e => reject(e))
      })
    },
    setConfiguration: async function (config) {
      return new Promise((resolve, reject) => {
        http.post(process.env.VUE_APP_API_ORIGIN + '/api/userconfig/update', config).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  notice: {
    getEnableNotices: async function () {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/notice/enables').then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  },
  tag: {
    getTags: async function (categoryId) {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/tag/list/' + categoryId).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    },
    getTagGroups: async function (categoryId) {
      return new Promise((resolve, reject) => {
        http.get(process.env.VUE_APP_API_ORIGIN + '/api/tag/groups/' + categoryId).then(response => {
          resolve(response.data)
        }).catch(e => reject(e))
      })
    }
  }
}

export default api
